export const RPMCalendar = (function () {
	'use strict';

	let weeklyCalendar, calendar, performanceName, $windowWidth, breakpoint, daysOfTheWeek;

	function init() {
		weeklyCalendar = document.querySelector('#weekly-calendar');
		calendar = document.querySelector('#cal');
		performanceName = 'How-To-Dance-In-Ohio';
		$windowWidth = $(window).width();
		breakpoint = 768;

		daysOfTheWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

		if (weeklyCalendar && weeklyCalendar.dataset.events) {
			weekly();
		}
		if (calendar && calendar.dataset.events) {
			monthly();
		}

		// If mobile on init
		if ($windowWidth < breakpoint) {
			renderToggle();
		}
		// on window resize, rerender action
		$(window).resize(function () {
			$windowWidth = $(window).width();
			renderToggle();
		});
	}

	function renderToggle() {
		if ($windowWidth > breakpoint) {
			return;
		}
		// console.log('in it');
		let $container = $('.rpmblock--calendar__container');
		let $buttons = $container.find('.rpmblock--calendar__monthly-button');

		$buttons.each(function () {
			$(this).on('click', function () {
				// Apply active class and remove active class from siblings
				$(this).addClass('active').siblings().removeClass('active');

				// Finds the ID to what needs to show.
				let button_id = $(this).attr('aria-controls');

				// Finds ID based off the button and updates active classes
				$container.find('.toggle-cal').removeClass('active').fadeOut();
				$container
					.find('.toggle-cal--' + button_id)
					.addClass('active')
					.fadeIn();
				$container.find('.rpmblock--calendar__monthly-info span').text(button_id);
			});
		});
	}

	function weekly() {
		var COMMONUTILS = {
			pageWidth: function () {
				'use strict';
				return document.documentElement.clientWidth;
			},
			userLocation: function () {
				'use strict';
				SCHEDULE.initWeekly('#weekly-calendar');
				SCHEDULE.Fetch(weeklyCalendar.dataset.events, function () {
					SCHEDULE.Weekly('#weekly-calendar');
				});
			},
		};

		var SCHEDULE = {
			Times: null,
			Avail: null,
			Schedule: null,

			getData: function (schedule, targetdiv, href) {
				$.getJSON(
					schedule,
					{
						format: 'json',
					},
					function (data) {
						var dd = new Date();
						var dn = dd.getMonth();
						dn++; // because months are 0 indexed

						for (di = 0; di <= data.schedule_info.length; di++) {
							// changed < to <= to compare fill length
							currentMonth = Number(data.schedule_info[0].dateID);
							if (currentMonth < dn) {
								data.schedule_info.shift();
							}
						}

						$('.cal-right').click(function (e) {
							e.preventDefault();
							var months = $('.month').length - 1;
							var next = $('.month:visible').index();

							if ($('.cal-left').hasClass('inactive')) {
								$('.cal-left').removeClass('inactive');
							}
							if ($('.month:visible').index() < months) {
								$('.month:visible').hide();
								$('.month').eq(next).fadeIn('slow');
							} else if ($('.month:visible').index() == months) {
								$(this).addClass('inactive');
								$('.month:visible').hide();
								$('.month').eq(next).fadeIn('slow');
							}
						});

						$('.cal-left').click(function (e) {
							e.preventDefault();
							var months = 1;
							var next = $('.month:visible').index() - 2;
							if ($('.cal-right').hasClass('inactive')) {
								$('.cal-right').removeClass('inactive');
							}
							if ($('.month:visible').index() > months) {
								$('.month:visible').hide();
								$('.month').eq(next).fadeIn('slow');
							} else if ($('.month:visible').index() == months) {
								$(this).addClass('inactive');
								$('.month:visible').hide();
								$('.month').eq(next).fadeIn('slow');
							}
						});
					}
				);
			},

			// Get JSON file, call appropriate parsing function after
			Fetch: function (source, callback) {
				if (typeof source === 'string') {
					let data = JSON.parse(source);
					SCHEDULE.Times = data.schedule_info;
					callback();
				} else {
					$.getJSON(source, function (data) {
						// console.log('here', data);
						// Format dates if Ticketmaster calendar
						SCHEDULE.Times = data.schedule_info;
						// console.log('schedule times set');
						callback();
					});
				}
			},

			// Populates Schedule Menu
			PopulateWeekly: function (container, eventslist) {
				// console.log('here', eventslist);

				//Append ticket links to corresponding date div
				for (var i = 0; i < eventslist.length; i++) {
					//var eventDate = "." + eventslist[i].start.slice(-5);
					let eventDate = '.' + eventslist[i].start;
					let eventTime = eventslist[i].title;
					let isBest = eventslist[i].best ? 'event-time--best' : '';
					let isFreePerformance = eventslist[i].freeperformance ? 'event-time--free-performance' : '';
					let eventInfo;

					eventTime = eventTime.replace(':00', "<span class='mins'>:00</span>");

					// console.log(eventslist[i]);
					// var eventInfo = "<a class='matweekly " + isBest + " '" + eventTime + " target='_blank' href='" + eventslist[i].url + "'>" + eventTime + "</a>";
					if (eventslist[i].featured) {
						eventInfo = "<div class='featured-artist' href='" + eventslist[i].url + "'><span>" + eventslist[i].featured + '</span></div>';
					} else if (eventslist[i].freeperformance) {
						eventInfo = "<a class='matweekly event-time " + isFreePerformance + "' target='_blank' href='" + eventslist[i].url + "'>" + eventTime + '</a>';
					} else {
						eventInfo = "<a class='matweekly event-time " + isBest + "' target='_blank' href='" + eventslist[i].url + "'>" + eventTime + '</a>';
					}

					console.log('Free Performance Value:', eventslist[i].free_performance);

					// Best availability (weekly on homepage)
					$('#weekly-calendar').find(eventDate).find('.tc').append(eventInfo);
				}
			},

			// WEEKLY LINK FORMATTING
			// Call this for Ticketmaster calendars with direct performance ticket links
			Weekly: function (container) {
				var eventslist = [];

				//Date fix
				var calDate = new Date();
				calDate.setDate(calDate.getDate() - 1);

				//var wDays = 0;

				// Format events for calendar
				for (var i = 0; i < Object.keys(SCHEDULE.Times).length; i++) {
					var showYear = SCHEDULE.Times[i].year;
					var showMonth = SCHEDULE.Times[i].dateID;
					if (showMonth.length < 2 && showMonth < 10) {
						// +0 to front of time if needed
						var zeroString = '0';
						showMonth = zeroString.concat(showMonth);
					}
					var linkMonth = showMonth;
					var hoursKey = Object.keys(SCHEDULE.Times[i].hours);

					for (var j = 0; j < hoursKey.length; j++) {
						var showDay = hoursKey[j];
						var timesKey = Object.keys(SCHEDULE.Times[i].hours[showDay]);
						for (var k = 0; k < timesKey.length; k++) {
							var eveMat = timesKey[k];
							var theTime = SCHEDULE.Times[i].hours[showDay][eveMat];
							var linkTime = theTime;
							var featured = theTime.artist ?? '';

							if (linkTime && linkTime.length < 7) {
								// +0 to front of time if needed
								var zeroString = '0';
								linkTime = zeroString.concat(linkTime);
							}
							if (eveMat != 'dark') {
								var linkDay = (Number(showDay) + 1).toString();
								if (linkDay.length < 2 && linkDay < 10) {
									// +0 to front of time if needed
									var zs = '0';
									linkDay = zs.concat(linkDay);
								}
								let showDate = linkMonth + '/' + linkDay + '/' + showYear;
								var startDate = showYear + '-' + showMonth + '-' + linkDay;

								//  If Time OR Featured Exists
								// AND date is before today
								if (theTime.time || (featured && calDate <= new Date(startDate))) {
									// console.log('in here',  calDate,new Date(startDate))

									eventslist.push({
										start: startDate, // previously: SCHEDULE.Times[i].date,
										url: 'http://www.telecharge.com/Broadway/' + performanceName + '/Ticket?PerformanceDateTime=' + showDate + '%20' + linkTime.time + 'PM' + '&AID=BWY001396000&utm_source=show_site&utm_campaign=How-To-Dance-In-OhioSS&utm_medium=web',
										title: theTime.time + '<span class="ampm">PM</span>',
										best: theTime.best,
										freeperformance: theTime.freeperformance,
									});
								}
								// console.log('out here')
							}
						}
					}
					/*
					wDays++;
					if (wDays == 7) { break; }
					*/
				}
				SCHEDULE.PopulateWeekly(container, eventslist);
			},

			//calendar creation function
			initWeekly: function (container) {
				var months = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];

				var calText = '';
				document.getElementById('weekly-calendar').innerHTML = calText;

				var block = document.querySelector(container);
				var blockToday = new Date();
				var startCustom = new Date(block.dataset.start);
				// If user selects start date && before today
				var commence = blockToday <= startCustom ? startCustom : blockToday;

				var thisDay = new Date(commence);
				var weekday = new Array(7);

				weekday[1] = 'MON';
				weekday[2] = 'TUE';
				weekday[3] = 'WED';
				weekday[4] = 'THU';
				weekday[5] = 'FRI';
				weekday[6] = 'SAT';
				weekday[0] = 'SUN';

				// get today's date
				var d = thisDay.getDate();
				var m = thisDay.getMonth();
				var y = thisDay.getFullYear();
				var n = weekday[thisDay.getDay()];

				// generate weekday names
				calText += '<div class="week-row week-names">';
				for (let i = thisDay.getDay(); i < thisDay.getDay() + 7; i++) {
					let the_day = i;
					if (the_day > 6) {
						the_day = the_day - 7;
					}
					calText += '<div>' + weekday[the_day] + '</div>';
				}
				calText += '</div>';

				//calText = '<div class="month row-fluid"><h3 class="col-sm-5 text-center">' + months[m] + " " + y + '</h3><h5 class="col-sm-7 text-center">CLICK ON A DATE TO BUY ONLINE.</h5><div><div class="date">Sun</div><div class="date">Mon</div><div class="date">Tue</div><div class="date">Wed</div><div class="date">Thu</div><div class="date">Fri</div><div class="date">Sat</div>';

				calText += '<div class="week-row">'; // open a week row
				for (let j = 0; j < 14; j++) {
					var d = thisDay.getDate();
					var m = thisDay.getMonth();
					var month = months[m];
					var y = thisDay.getFullYear();
					var n = weekday[thisDay.getDay()];

					if (m < 9) {
						if (d <= 9) {
							var thisDate = y + '-0' + (m + 1) + '-0' + d;
						} else {
							var thisDate = y + '-0' + (m + 1) + '-' + d;
						}
					} else {
						if (d <= 9) {
							var thisDate = y + '-' + (m + 1) + '-0' + d;
						} else {
							var thisDate = y + '-' + (m + 1) + '-' + d;
						}
					}

					calText += `<div class="date-box ${thisDate}">
							<div class="date-box-content">
								<p class="day-weekly">
									${n}
								</p>
								<div class="weekday-box">
									<div class="date">										
										<div class="date__date">
											<p>${n}</p>
											<p>${d > 9 ? d : '0' + d}</p>
										</div>
									</div>
									<div class="weekly-perf-holder">
										<div class="t">
											<div class="tc">
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>`;
					//calText += "<div class=\"day active "+thisDate+" ind"+ind+"\" data-date=\""+thisDate+"\" data-ind=\""+ind+"\"><span class=\"num\">" + j + "</span></div>";
					// calText += '</div></div></div></div></div></div>';
					//ind++;

					thisDay.setDate(thisDay.getDate() + 1);

					// // wrap after 7 days; change to a new week row
					// if (j == 6) {
					// 	calText +=
					// 		'</div><!-- end interim week row --><div class="week-row">';
					// }
				}
				calText += '</div><!-- end week row -->'; // close a week row

				document.getElementById('weekly-calendar').innerHTML += calText;

				calText = '';

				//}
			},
		};
		COMMONUTILS.userLocation(COMMONUTILS.currentPage);
	}

	function monthly() {
		var COMMONUTILS = {
			//
			pageWidth: function () {
				'use strict';
				return document.documentElement.clientWidth;
			},

			// OBJ TO HOLD USERS CURRENT WEBPAGE LOCATION
			// currentPage: window.location.pathname.substring(window.location.pathname.lastIndexOf('/') + 1),
			currentPage: window.location.pathname.replace(/\//g, ''),

			// FUNCTION TO EXECUTE CODE BASED ON LOCATION
			userLocation: function (pagename) {
				'use strict';
				let parsedEvents = JSON.parse(calendar.dataset.events);
				// console.log(SCHEDULE.sched);

				SCHEDULE.getData(SCHEDULE.sched, '#cal', performanceName);
			},
		};

		// NAMESPACE FOR SCHEDULE FUNCTIONS
		var SCHEDULE = {
			// JSON results for show dates and times will be stored here
			Times: null,
			Avail: null,
			sched: JSON.parse(calendar.dataset.events),
			Schedule: null,

			getData: function (schedule, targetdiv, href) {
				SCHEDULE.Schedule = schedule;
				var results = SCHEDULE.schedulePop(SCHEDULE.Schedule, href); //********
				$(targetdiv).append(results);

				function resetArrowsIfNoMonths() {
					var months = $('.month').length;
					var next = $('.month:visible').index();

					// console.log("right months: ", months);
					// console.log("right next: ", next);
					if (months == next) {
						$('.cal-left, .cal-right').addClass('inactive');
					}
				}
				resetArrowsIfNoMonths();

				$('.cal-left').click(function (e) {
					e.preventDefault();
					var months = $('.month').length;
					var prev = $('.month:visible').index() - 1;

					if ($('.cal-right').hasClass('inactive')) {
						$('.cal-right').removeClass('inactive');
					}

					// console.log("left months: ", months);
					// console.log("left prev: ", prev);

					if (prev > 0) {
						// console.log('continue');
						$('.month:visible').hide();
						$('.month').eq(prev).fadeIn('slow');
					} else if (prev == 0) {
						// console.log('stop');
						$('.cal-left').addClass('inactive');
						$('.month:visible').hide();
						$('.month').eq(prev).fadeIn('slow');
					}
				});

				$('.cal-right').click(function (e) {
					e.preventDefault();
					var months = $('.month').length - 1;
					var next = $('.month:visible').index() + 1;

					// console.log("right months: ", months);
					// console.log("right next: ", next);

					if ($('.cal-left').hasClass('inactive')) {
						$('.cal-left').removeClass('inactive');
					}

					if (next < months) {
						// console.log('continue');
						$('.month:visible').hide();
						$('.month').eq(next).fadeIn('slow');
					} else {
						// console.log('stop');
						$('.month:visible').hide();
						$('.month').eq(next).fadeIn('slow');
						$('.cal-right').addClass('inactive');
					}
				});
			},

			// Get JSON file, call appropriate parsing function after
			Fetch: function (source, callback) {
				$.getJSON(source, function (data) {
					// Format dates if Ticketmaster calendar
					SCHEDULE.Times = data;
					callback();
				});
			},

			// Populates Schedule Menu
			schedulePop: function (schedule, href) {
				var today = new Date();
				var schedule_info = schedule.schedule_info;

				// remove previous months, respecting month AND year
				var today = new Date();
				var dmo = today.getMonth();
				dmo++; // because months are 0 indexed
				var dy = today.getFullYear();
				var monthYear = new Date(dy, dmo);

				for (let di = 0; di < schedule_info.length; di++) {
					var currentMonthYear = new Date(schedule_info[0].year, schedule_info[0].dateID);
					if (currentMonthYear.getTime() < monthYear.getTime()) {
						// console.log("shifted");
						schedule_info.shift();
					}
				}

				var months = schedule_info.length;
				var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
				var schedule_html = '';

				// Add 0 to single digit months
				// Index starts at 0 so 9 === October
				var todayMonth = today.getMonth() < 9 ? '0' + (today.getMonth() + 1).toString() : (today.getMonth() + 1).toString();

				for (var i = 0; i < months; i++) {
					var calendar = '';
					let scheduleMonthNumber = schedule_info[i].dateID;
					let scheduleMonthDays = schedule_info[i].days;
					let scheduleMonthYear = schedule_info[i].year;
					let scheduleMonthHours = schedule_info[i].hours;
					let todayMonthNumber = today.getMonth() + 1; // +1 is needed to start iteration at 1
					let todayDateNumber = today.getDate();
					let todayYearNumber = today.getFullYear();

					// IF IT'S THIS MONTH ( DISPLAYS PAST DATES DARK )
					// This dictates the appropriate month number in the calendar dates when rendered on the frontend.
					if (scheduleMonthNumber == todayMonthNumber.toString() && scheduleMonthYear == todayYearNumber.toString()) {
						for (let dayNumber = 1; dayNumber <= Number(scheduleMonthDays); dayNumber++) {
							let scheduleHours = schedule_info[i].hours;
							// dayNumber = iterates every day in the month
							if (todayDateNumber > dayNumber) {
								// days before today
								let currentDayBeforeToday = new Date(todayMonth + ' ' + dayNumber + ' ' + scheduleMonthYear);
								// if(currentDayBeforeToday.getDate())
								// if( ((today.getDate()-7 ) < currentDayBeforeToday.getDate()) &&  currentDayBeforeToday.getDay() < today.getDay()) {
								// console.log(today.getDate()-7, currentDayBeforeToday.getDate(), currentDayBeforeToday.getDay(), today.getDay());
								calendar += `<div class="day-box ${today.getDate() === dayNumber ? 'day-box--today' : ''} dark">
											<p class="date-2">
												${renderDateNumber(dayNumber)}
											</p>
										</div>`;
								// }
							} else {
								if (scheduleHours[dayNumber - 1] && Object.keys(scheduleHours[dayNumber - 1])[0] != 'dark') {
									// Render Date/Times Here
									var datedeets = scheduleHours[dayNumber - 1];
									calendar += `<div class="day-box day-box--perf ${todayDateNumber === dayNumber ? 'day-box--today' : ''} ${schedule_info[i].dateID}-${todayMonth < 10 ? '0' + todayMonth : todayMonth}/${dayNumber < 10 ? '0' + dayNumber : dayNumber}">
											<p class="date-2">
												${dayNumber < 10 ? '0' + dayNumber : dayNumber}
											</p>
											<div class="perf-links-holder">`;

									for (var key in datedeets) {
										var date = new Date(schedule_info[i].dateID + '/' + dayNumber + '/' + schedule_info[i].year);
										var showtime = datedeets[key];
										var linkDate = schedule_info[i].dateID;

										showtime = showtime.length < 5 ? '0'.concat(showtime) : showtime; // +0 to front of showtime if needed
										calendar += renderPerformanceLink(key, scheduleMonthNumber, dayNumber, schedule_info[i].year, showtime.time, datedeets[key].best, datedeets[key].freeperformance);
									}
									calendar += `</div></div>`;
								} else {
									// If Day has no performance, show empty
									// Fixes issue of some empty dates displaying previous month number
									// ((today.getMonth() + 1) < 10 ? '0' + (today.getMonth() + 1) : (today.getMonth() + 1))
									calendar += `<div class="day-box dark ${todayDateNumber === dayNumber ? 'day-box--today' : ''}">
											<p class="date-2">
												${renderDateNumber(dayNumber)}
											</p>
										</div>`;
								}
							}
						}
					} else {
						// IF IT'S NOT THIS MONTH ( DISPLAYS FULL MONTH )
						for (let dayNumber = 1; dayNumber <= Number(schedule_info[i].days); dayNumber++) {
							if (scheduleMonthHours[dayNumber - 1] && Object.keys(scheduleMonthHours[dayNumber - 1])[0] != 'dark') {
								var datedeets = scheduleMonthHours[dayNumber - 1];

								calendar += `<div class="day-box ${schedule_info[i].dateID}-${dayNumber}">
										<p class="date-2">
											${dayNumber < 10 ? '0' + dayNumber : dayNumber}
										</p>
										<div class="perf-links-holder perf-links-holder--future">`;

								for (var key in datedeets) {
									var showtime = datedeets[key];
									showtime = showtime.length < 5 ? '0'.concat(showtime) : showtime; // +0 to front of showtime if needed
									calendar += renderPerformanceLink(key, scheduleMonthNumber, dayNumber, schedule_info[i].year, showtime.time, datedeets[key].best, datedeets[key].freeperformance);
								}

								calendar += '</div></div>';
							} else {
								// console.log('in', m);
								calendar +=
									'<div class="day-box dark"><p class="date-2">' +
									// (schedule_info[i].dateID < 10
									// 	? '0' + schedule_info[i].dateID
									// 	: schedule_info[i].dateID) +
									// '/' +
									(dayNumber < 10 ? '0' + dayNumber : dayNumber) +
									'</p></div>';
							}
						}
					}

					let exemption_text = schedule_info[i].full_month === 'July' ? '<div class="month__exempt"><p style="text-align: center;"></p></div>' : '';
					let isCurrentMonth = parseInt(schedule_info[i].dateID) === today.getMonth() + 1 ? 'month--current' : '';

					// console.log('here,',schedule_info[i]);

					schedule_html =
						schedule_html +
						`<div class="month ${isCurrentMonth}">
							${exemption_text}
							<div class="month-hed">
								<div class="cal-header no-best-dates">
									<div class="cal-nav">
										<button class="cal-left inactive" >
											<span class="arrow"><i class="fas fa-caret-left"></i></span>
										</button>
										<button class="cal-right" >
											<span class="arrow"><i class="fas fa-caret-right"></i></span>
										</button>
										${renderMonthTitle(schedule_info[i].full_month, '')}
									</div>
									<div class="best-info">
										<p>Click on a performance time in the calendar to get tickets.</p>
									</div>
									<div class="best-box">
										<div class="best-box__each">
											<div class="best-box__color"></div>
											<div class="best-box__text"><p>Best Availability</p></div>
										</div>
										<div class="best-box__each hide">
											<div class="best-box__free-performance-color"></div>
											<div class="best-box__text best-box__text--free-performance"><p></p></div>
										</div>
									</div>
								</div>
							</div>
							<div class="grid-container">
								<div class="days">
									<div class="day">Sun</div>
									<div class="day">Mon</div>
									<div class="day">Tue</div>
									<div class="day">Wed</div>
									<div class="day">Thu</div>
									<div class="day">Fri</div>
									<div class="day">Sat</div>
								</div>
								<div class="grid">
									${renderBeforeOffsetDays(schedule_info[i].offset, schedule_info[i - 1])}
									${calendar}
									${renderAfterOffsetDays(schedule_info[i].after, schedule_info[i + 1], schedule_info[i])}
								</div>
							</div>
						</div>
					`;
				}

				return schedule_html;
			},
		};

		COMMONUTILS.userLocation(COMMONUTILS.currentPage);
	}

	function renderPerformanceLink(key, date, dayNumber, year, showtime, isBest, isFreePerformance) {
		let performanceLink = '';

		const today = new Date();

		const september2nd = new Date(today.getFullYear(), 8, 2);
		const september4th = new Date(today.getFullYear(), 8, 4);
		const performanceDate = new Date(year, date - 1, dayNumber); // month is 0-indexed

		const isEventOnSeptember2nd = performanceDate.getDate() === september2nd.getDate() && performanceDate.getMonth() === september2nd.getMonth() && performanceDate.getFullYear() === september2nd.getFullYear();

		const performanceName = 'How-To-Dance-In-Ohio';
		// Conditional for dates after Sep 4th
		//  performanceDate >= september4th ? 'How-To-Dance-In-Ohio-after-September-4' :

		const bestClass = isBest ? 'event-time--best' : '';
		let freePerformanceClass = isFreePerformance ? 'event-time--free-performance' : '';

		// Check if it's September 2nd and matinee time (assuming matinee is before 5 PM for example)
		// Angel: Removed per James
		// if (isEventOnSeptember2nd && parseInt(showtime, 10) < 5) {
		// 	freePerformanceClass = 'event-time--free-performance';
		// }

		performanceLink += `
    <a class="cal-link event-time ${bestClass} ${freePerformanceClass} ${key}" href="http://www.telecharge.com/Broadway/${performanceName}/Ticket?PerformanceDateTime=${date}/${dayNumber}/${year}%20${showtime}PM${
			'&AID=BWY001396000&utm_source=show_site&utm_campaign=How-To-Dance-In-OhioSS&utm_medium=web'
			// Brian: Removed, left in case telecharge decides to revert back
			// performanceName === 'How-To-Dance-In-Ohio-after-September-4' ? '&AID=BWY001396000&utm_source=show_site&utm_campaign=How-To-Dance-In-Ohio-after-September-4SS&utm_medium=web' : ''
		}" target="_blank">
        ${showtime} <span class="no-pm-mobile">pm</span>
    </a>`;

		// console.log(performanceLink);
		return performanceLink;
	}

	function renderDateNumber(dayNumber) {
		// return dayNumber < 10 ? '0' + dayNumber : dayNumber;
		return dayNumber;
	}

	function renderMonthTitle(month, year) {
		let title = '';
		title += `<h3 class="mobilemonth">${month} ${year}</h3>`;
		return title;
	}

	function renderBeforeOffsetDays(offsetDays, prevMonth) {
		let before = ''; // setup blank days before first day of month
		let prevMonthDays = prevMonth && prevMonth.days ? prevMonth.days : 31;
		let offsetDaysMath = prevMonthDays - offsetDays + 1;

		for (var f = offsetDaysMath; f <= parseFloat(prevMonthDays); f++) {
			// console.log('fsdf', f)
			before += `
				<div class="day-box off_set off_set--before">
					<p class="date-2">${renderDateNumber(f)}</p>
					&nbsp;
				</div>`;
		}
		return before;
	}

	function renderAfterOffsetDays(offsetDays, nextMonth, current) {
		let after = ''; // setup blank days after last day of month
		let nextMonthDays = 0;
		if (nextMonth) {
			// console.log(nextMonth);
			nextMonthDays = nextMonth.offset && nextMonth.offset > 0 ? 7 - nextMonth.offset : 0;
		} else {
			nextMonthDays = current.after;
		}

		for (var t = 1; t <= parseFloat(nextMonthDays); t++) {
			after += `<div class="day-box off_set off_set--after">
				<p class="date-2">${renderDateNumber(t)}</p>
				&nbsp;
			</div>`;
		}
		return after;
	}

	return {
		init: init,
	};
})();

